import moment, { MomentInput, unitOfTime } from 'moment';

export const dateFormatter = (date: MomentInput, format = 'MMM DD, YYYY'): string =>
  moment.utc(date).add(moment().utcOffset(), 'm').format(format);
export const dateForInterview = (date: MomentInput, format = 'LT'): string =>
  moment(date, format as string)
    .add(30, 'minutes')
    .format(format);
export const timeValue = (date: MomentInput, format = 'YYYY-MM-DD HH:mm:ssZ'): string =>
  moment(date, format).format('HH:mm');
export const allDate = (date: MomentInput, format = 'YYYY-MM-DDTHH:mm:ssZ'): Date => moment(date, format).toDate();
export const utcTime = (date: MomentInput): string => moment.utc(moment(date, 'HH:mm')).format('HH:mm:ssZ');
export const utcTimeForRooms = (date: MomentInput): string => moment.utc(moment(date, 'HH:mm')).format('HH:mm');
export const utcFormatDate = (date: MomentInput): string =>
  moment.utc(date).toISOString().split('.')[0] + moment().format('Z');
export const getTotalTime = (date: MomentInput, type: unitOfTime.All): number => moment(date, 'HH:mm').get(type);
export const reminderDate = (data: { datetime: string | number | Date }): string =>
  moment.utc(moment(new Date(data.datetime).toUTCString()), 'YYYY-MM-DD-HH-mm').toISOString();
export const getDateForAnalitics = (value: MomentInput): string => moment(value).format('YYYY-MM-DD');
